import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import Switch from '@material-ui/core/Switch';
import ActionButton from "../general/ActionButton";
import {
  getBrokeragesList,
  loadBrokerages,
  brokerageSelected
} from "../store/brokerages";
import Select from "react-dropdown-select";

const BrokerageSuperAdminCustomizeAPI = () => {
  const dispatch = useDispatch();
  const [selectedCode, setSelectedCode] = useState(null);
  useEffect(() => {
    dispatch(loadBrokerages());
  }, [dispatch]);
  const onChangeHandle = (value) => {
    //dispatch(getDetailsAdmin(value[0].code));
    setSelectedCode(value[0].code);
  };
  const brokerages = useSelector(getBrokeragesList);
  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
        }}
      >
        <div style={{ width: "80%", marginLeft: "10%", marginTop: "20px" }}>
          <Select
            placeholder={"Search for a brokerage"}
            color={theme.COLORS.primary_navyblue}
            searchable={true}
            onChange={(values) => onChangeHandle(values)}
            values={[]}
            options={brokerages}
            style={{
              width: "100%",
              height: "6vh",
              fontSize: "1.9vmin",
              border: "5px solid white",
              borderRadius: 15,
              fontFamily: "GibsonRegular",
            }}
            labelField={"name"}
            valueField={"code"}
            dropdownHeight={"58vh"}
          />
        </div>
      </div>
      <CustomizeAPIPane></CustomizeAPIPane></div>
  );
};

const CustomizeAPIPane = () => {
  return (
    <div
      style={{
        margin: "3.5rem",
        marginTop: "1.5rem"
      }}
    >
      <div>
        <h5 class="px-2" style={{
          fontFamily: "GibsonSemiBd",
          justifyContent: "center",
          fontSize: "1.2vw",
        }}>There are various external data sources that you can enable or disable for all users at your brokerage.  These can help to take your service to the next level.</h5>
        <h5 class="px-2" style={{
          fontFamily: "GibsonRegular",
          justifyContent: "center",
          fontSize: "1vw",
        }}>Any activated external data sources are charged to your brokerage at cost each time a data call is made.  Current charges are shown below and subject to change in line with changes from data provider.</h5>
        <CustomizeAPIItems />
      </div>
    </div>
  );
};

const CustomizeAPIItems = () => {
  return (
    <div class="m-4">
      <table style={{ fontFamily: "GibsonRegular", fontSize: "0.8vw" }} class="table table-sm">
        <thead>
          <tr class="thead-light" >
            <th scope="col">Data Source</th>
            <th scope="col">Information</th>
            <th scope="col">Cost</th>
            <th scope="col">Active?</th>
          </tr>
        </thead>
        <tbody>
          <tr scope="row">
            <td>Google Address Fill</td>
            <td>Quotey will prefill addresses when the user begins typing them. This one is on the house!</td>
            <td>Free</td>
            <td><Switch checked={true} disabled={true} /></td>
          </tr>
          {/* <tr scope="row">
          <td>FUS Score</td>
          <td>Quotey can automatically pull the FUS score of any locations to save precious time on Google Streetview finding proximity to fire hydrants and Fire Halls.</td>
          <td>$4.45</td>
          <td><Switch color="primary"/></td>
        </tr> */}
        </tbody>
      </table>
      <div class="m-2" style={{ width: "10%", float: "right" }}>
        <ActionButton text="Save"></ActionButton>
      </div>
    </div>
  );
};

export default BrokerageSuperAdminCustomizeAPI;
